/**
 * dragslideshow.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */


var helpers = require('./helpers'),
	gsap = require('gsap');

require('../../../vendors/gsap/src/uncompressed/utils/Draggable');

function DragSlideshow( el, options ) {	

	var self = this;
	this.el = el;
	this.$slideshow = $(el)
	this.$window = $(window);
	this.minDragPerc = 0.1;
	this.support = { transitions : Modernizr.csstransitions };
	this.options = $.extend({
		perspective : '1200',
		slideshowRatio : 0.6, // between: 0,1
		onToggle : null,
		onMoveStart: null,
		onMoveEnd: null,
		onResize: null
	},options);

	self.transEndEventNames = {
		'WebkitTransition': 'webkitTransitionEnd',
		'MozTransition': 'transitionend',
		'OTransition': 'oTransitionEnd',
		'msTransition': 'MSTransitionEnd',
		'transition': 'transitionend'
	};
	self.transEndEventName = self.transEndEventNames[ Modernizr.prefixed( 'transition' ) ];


	$(window).on('resize', function(){
		self.reflow();
	})

	this._init();
}

/**
 * init function
 * initialize and cache some vars
 */
DragSlideshow.prototype._init = function() {
	var self = this;

	this.isFullscreen = true;
	this.imgDragger = this.el.querySelector( 'section.dragdealer' );
	this.handle = this.imgDragger.querySelector( 'div.handle' );
	this.$handle = $(this.handle);
	this.slides = [].slice.call( this.handle.children );
	this.current = this.$handle.find('.slide').filter('.current').index();
	this.slidesCount = this.slides.length;

	this.slideshowRatio = this.options.slideshowRatio;
	classie.add( this.slides[ this.current ], 'current' );
	this.handle.style.width = this.slidesCount * 100 + '%';
	this.slides.forEach( function( slide ) {
		slide.style.width = 100 / self.slidesCount + '%';
	} );
	this._initDragDealer();
	this._initEvents();

}

/**
 * initialize the events
 */
DragSlideshow.prototype._initEvents = function() {
	var self = this;
	
	// this.slides.forEach( function( slide ) {
	// 	// clicking the slides when not in isFullscreen mode
	// 	slide.addEventListener( 'click', function() {
	// 		if( self.isFullscreen || self.dd.activity || self.isAnimating ) return false;
			
	// 		if( self.slides.indexOf( slide ) === self.current ) {
	// 			self.toggle();
	// 		}
	// 		else {
	// 			self.dd.setStep( self.slides.indexOf( slide ) + 1 );
	// 		}
	// 	} );

	// } );

	// keyboard navigation events
	document.addEventListener( 'keydown', function( ev ) {
		var keyCode = ev.keyCode || ev.which,
			currentSlide = self.slides[ self.current ];

		switch (keyCode) {
			case 37:
				self.moveToDirection(false);
				break;
			case 39:
				self.moveToDirection(true);
				break;
		}

	} );
}

/**
 * initialize the Dragdealer plugin
 */
DragSlideshow.prototype._initDragDealer = function() {
	var self = this;


    self.dd = Draggable.create(self.$handle, {
        type: 'x',
        edgeResistance: 0.5,
        dragResistance: (Modernizr.touchevents) ? 0.1 : 0.5,
        zIndexBoost: false,
        force3D: true,
        throwProps: true,
        lockAxis: true,
        maxDuration: 1,
        dragClickables: true,
        onDrag: function(){

        	// var width = self.$handle.width();
        	// var perc = Math.abs(this.x) / (width - self.$slideshow.find('.img-dragger').width());
        	// $('#linee-cover-wrap .timeline span').css('left', (perc*100) + '%')

        },
        onDragStart: function(e){
        	if(typeof self.options.onMoveStart == 'function')
		    	self.options.onMoveStart(self.current);
        },
        onDragEnd: function(e){

        	var direction = this.getDirection();
        	var xMove = Math.abs(this.x);

        	// var width = self.$handle.width();
        	// console.log(Math.abs(this.x) / (width - self.$slideshow.width()));


        	if(xMove > self.$window.width() * self.minDragPerc){

        		if(direction == 'left'){

        			self.moveToDirection(true);

        		}else{

        			self.moveToDirection(false);

        		}

        	}else{

    			self.moveToCurrent();

        	}

        }
    });
    self.reflow();

}

DragSlideshow.prototype.moveToDirection = function(next){

	var self = this;

	var tempNext = self.current + (next ? 1 : -1);

	if(!next && self.current == 0){
		tempNext = 0;
	}else if(next && self.current >= self.slidesCount - 1){
		tempNext = self.slidesCount - 1;
	}

	var val = self.$slideshow.find('.img-dragger').width() * tempNext;

	self.current = tempNext;
	self.moveTo(val);

}

DragSlideshow.prototype.moveToCurrent = function(){

	var self = this

	self.moveTo(self.$slideshow.width() * self.current)

}


DragSlideshow.prototype.moveTo = function(val, callback){

	var self = this
    gsap.killTweensOf(self.$handle);


	var width = self.$handle.width();
	$('#linee-cover-wrap .timeline span').css('left', (self.current / self.slidesCount * 100) + '%')

    gsap.to(self.$handle, .5, {
        x: -val,
        ease: Power2.easeInOut,
        onComplete: function() {
        	if(typeof self.options.onMoveEnd == 'function')
		    	self.options.onMoveEnd(self.current);
        }
    });

}

DragSlideshow.prototype.current = function(){

}

DragSlideshow.prototype.getCurrent = function(){

	var self = this;
	return self.current;

}

DragSlideshow.prototype.reflow = function(){

	var self = this;
	var width = self.$handle.width();
	$('#linee-cover-wrap .timeline span').css('left', (self.current / self.slidesCount * 100) + '%')
    gsap.set(self.$handle, {
        x: - self.$slideshow.find('.img-dragger').width() * self.current,
        onComplete: function() {
        	if(typeof self.options.onResize == 'function')
		    	self.options.onResize(self.current);
        }
    });

}



































/**
 * toggle between fullscreen and minimized slideshow
 */
DragSlideshow.prototype.toggle = function() {

	var self = this;

	if( this.isAnimating ) {
		return false;
	}
	this.isAnimating = true;

	// add preserve-3d to the slides (seems to fix a rendering problem in firefox)
	this._preserve3dSlides( true );
	
	// callback
    if (typeof self.options.onToggle === 'function')
    	self.options.onToggle();

	classie.remove( this.el, this.isFullscreen ? 'switch-max' : 'switch-min' );
	classie.add( this.el, this.isFullscreen ? 'switch-min' : 'switch-max' );
	
	var self = this,
		p = this.options.perspective,
		r = this.options.slideshowRatio,
		zAxisVal = this.isFullscreen ? p - ( p / r ) : p - p * r;

	this.imgDragger.style.WebkitTransform = 'perspective(' + this.options.perspective + 'px) translate3d( -50%, -50%, ' + zAxisVal + 'px )';
	this.imgDragger.style.transform = 'perspective(' + this.options.perspective + 'px) translate3d( -50%, -50%, ' + zAxisVal + 'px )';

	var onEndTransitionFn = function( ev ) {

		if( self.support.transitions ) {
			if( ev.propertyName.indexOf( 'transform' ) === -1 ) return;
			this.removeEventListener( self.transEndEventName, onEndTransitionFn );
		}

		if( !self.isFullscreen ) {
			// remove preserve-3d to the slides (seems to fix a rendering problem in firefox)
			self._preserve3dSlides();
		}

		// replace class "img-dragger-large" with "img-dragger-small"

		var el = this;

		setTimeout(function(){

			classie.remove( el, self.isFullscreen ? 'img-dragger-large' : 'img-dragger-small' );
			classie.add( el, self.isFullscreen ? 'img-dragger-small' : 'img-dragger-large' );

			// reset transforms and set width & height
			self.imgDragger.style.WebkitTransform = 'translate3d( -50%, -50%, 0px )';
			self.imgDragger.style.transform = 'translate3d( -50%, -50%, 0px )';
			el.style.width = self.isFullscreen ? self.options.slideshowRatio * 100 + '%' : '100%';
			el.style.height = self.isFullscreen ? self.options.slideshowRatio * 100 + '%' : '100%';
			// reinstatiate the dragger with the "reflow" method
			self.reflow();

			// change status
			self.isFullscreen = !self.isFullscreen;
			self.isAnimating = false;
		},self.isFullscreen ? 1 : 300)
	};

	if( self.support.transitions ) {

		self.imgDragger.addEventListener( self.transEndEventName, onEndTransitionFn );

	}
	else {
		onEndTransitionFn();
	}
}

DragSlideshow.prototype.enable = function(){

	var self = this;
	self.$slideshow.removeClass('disabled');
	self.dd[0].enable();

}

DragSlideshow.prototype.disable = function(){

	var self = this;
	self.$slideshow.addClass('disabled');
	self.dd[0].disable();
	
}

DragSlideshow.prototype.navigate = function(toNext){

	var self = this;
	if(typeof self.options.onMoveStart == 'function')
    	self.options.onMoveStart(self.current);
	if(!toNext){
		self.moveToDirection( false );
	}else if(toNext){
		self.moveToDirection( true );
	}

}

/**
 * add/remove preserve-3d to the slides (seems to fix a rendering problem in firefox)
 */
DragSlideshow.prototype._preserve3dSlides = function( add ) {
	this.slides.forEach( function( slide ) {
		slide.style.transformStyle = add ? 'preserve-3d' : '';
	});
}

module.exports = DragSlideshow;



/** WEBPACK FOOTER **
 ** ./components/dragslideshow/dragslideshow.js
 **/